module.exports = __webpack_public_path__ + "static/img/实时监控1.9c2a648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/实时监控1.jpg
// module id = sPSp
// module chunks = 1